






































































































import { Component, Vue } from "vue-property-decorator";
import { VueEditor, Quill } from "vue2-editor";
import Content from "@/store/entities/content";
import Ajax from '../../../lib/ajax';
@Component({
  components: { VueEditor, Quill },
})

export default class ContentAdd extends Vue {
  dialog: boolean = true;
  content:Content=new Content();
  contentTypes:any[]=[];
  selectedContent:any={};
  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },

  

    };
  }
  async saveContent(){
    this.content.contentType=this.selectedContent.id;
    this.addContent();
  


  }

  async addContent() {
    if(!this.content.text){
      this.content.text=""
    }
    var formData = new FormData();
  formData.append('Text', this.content.text);
  formData.append('Title', this.content.title);
  formData.append('ContentType',this.content.contentType.toString());
  formData.append('ImageFile', this.content.imageFile);
  formData.append('OrderNo', this.content.orderNo.toString());


    const response = await Ajax.post('/api/services/app/Admin/SaveContent', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
  }

  created() {
    this.contentTypes= [
        { id: 0, name: "Header" },
        { id: 1, name: "Anasayfa" },
        { id: 2, name: "Footer" },
        { id: 3, name: "Slider" }
      ]
    }

openFileInput() {
  const fileInput = this.$refs.fileInput as HTMLInputElement | undefined;
  if (fileInput) {
    fileInput.click();
  }
}


handleFileChange(event) {
  const selectedFile = event.target.files[0];
  if (selectedFile) {
 
    this.content.imageFile=selectedFile;
    // Resim seçildiğinde bu kod çalışır
    const imagePreview = this.$refs.imagePreview as HTMLImageElement | undefined;
    if (imagePreview) {
      // Seçilen resmi önizleme alanında göster
      const reader = new FileReader();
      reader.onload = (e) => {
        if (typeof e.target.result === 'string') {
          imagePreview.src = e.target.result;
        }
      };
      reader.readAsDataURL(selectedFile);
    }
  }
}

  


  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }
}
